import { Checkbox, Col, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import InnerCardHeader from "../../../../components/atoms/cardHeader/InnerCardHeader";
import GeneralSettings from "./GeneralSettings";
import { useDispatch, useSelector } from "react-redux";
import {
  AddInventory,
  GetInventoryDetails,
  UpdateInventory,
  vendorStoresThunk,
} from "../../../../store/thunks/vendorStoreThunk";
import GstPan from "./GstPan";
import UploadedLicense from "./UploadedLicense";
import UploadLicense from "./UploadLicense";
import BottomRightButton from "../../../../components/atoms/formFields/buttons/bottomRightButton";
import TableLoader from "../../../../components/atoms/tableLoader";
import {
  resetAddInventory,
  resetUpdateInventory,
} from "../../../../store/slices/vendorStoreSlice";
import {
  isNumberOnly,
  isTenDigitMobile,
  isValidEmailStrict,
} from "../../../../utils/regex";
import DigitalSignature from "./DigitalSignature";

const Store = ({ storeId }) => {
  const { data, loading: detailLoading } = useSelector(
    (state) => state.inventoryDetails,
  );
  const { data: storeCreated, loading } = useSelector(
    (state) => state.addInventory,
  );
  const { loading: updateLoading, data: storeUpdated } = useSelector(
    (state) => state.updateInventory,
  );
  const dispatch = useDispatch();
  const GSTregex = /^[a-zA-Z0-9]{15}$/;
  const PANregex = /^[a-zA-Z0-9]{10}$/;

  const [logo, setLogo] = useState("");
  const [gstPan, setGstPan] = useState();
  const [status, setStatus] = useState();
  const [licenseError, setLicenseError] = useState([]);
  useEffect(() => {
    dispatch(resetAddInventory());
    dispatch(resetUpdateInventory());
    if (storeId) {
      dispatch(GetInventoryDetails({ inventoryId: storeId }));
    } else {
      setStoreObject({
        categoriesId: [],
        id: storeId || null,
        inStorePickup: false,
        licenseDetails: [],
        licenseRequest: [],
      });
      setLogo();
      setGstPan();
      setStatus();
      dispatch(vendorStoresThunk());
    }
  }, [storeId, storeCreated, storeUpdated]);
  // storeObject useState Hook
  const [storeObject, setStoreObject] = useState({
    categoriesId: [],
    id: storeId || null,
    inStorePickup: false,
    licenseDetails: [],
    licenseRequest: [],
    digitalSignature: null,
  });
  // Error useState Hook
  const [errors, setErrors] = useState({
    storeName: "",
    storeEmail: "",
    mobileNumber: "",
    storeAddressLine1: "",
    storeAddressLine2: "",
    storePasscode: "",
    longitude: "",
    latitude: "",
    state: "",
    district: "",
    digitalSignature: "",
  });

  
  useEffect(() => {
    if (data?.id) {
      setStatus(data?.status);
      const gstResponse = data?.gstResponse?.find(
        (gst) => gst.status !== "REJECTED" && gst.status !== "DELETED",
      );
      const panResponse = data?.panResponse?.find(
        (gst) => gst.status !== "REJECTED" && gst.status !== "DELETED",
      );
      setGstPan({
        ...gstPan,
        rejectedGST: data?.gstResponse?.filter(
          (gst) => gst.status === "REJECTED",
        ),
        deletedGST: data?.gstResponse?.filter(
          (gst) => gst.status === "DELETED",
        ),
        rejectedPAN: data?.panResponse?.filter(
          (pan) => pan.status === "REJECTED",
        ),
        deletedPAN: data?.panResponse?.filter(
          (pan) => pan.status === "DELETED",
        ),
      });
      setStoreObject({
        categoriesId: [],
        id: data?.id || "",
        inStorePickup: data?.inStorePickup || false,
        storeName: {
          en: data?.storeName?.en || "",
        },
        storeEmail: data?.storeEmail || "",
        locationRequest: {
          Description: {
            en: data?.location?.Description?.en || "",
          },
          storeAddressLine1: {
            en: data?.location?.storeAddressLine1?.en || "",
          },
          storeAddressLine2: {
            en: data?.location?.storeAddressLine2?.en || "",
          },
          storePasscode: data?.location?.storePasscode || "",
          state: {
            name: {
              en: data?.location?.state?.name?.en || "",
              hn: data?.location?.state?.name?.hn || "",
              pb: data?.location?.state?.name?.pb || "",
            },
            key: data?.location?.state?.key || "",
            id: data?.location?.state?.key || "",
          },
          city: {
            name: {
              en: data?.location?.city?.name?.en || "",
              hn: data?.location?.city?.name?.hn || "",
              pb: data?.location?.city?.name?.pb || "",
            },
            key: data?.location?.city?.key || "",
            id: data?.location?.city?.key || "",
          },
          landMark: {
            en: data?.location?.landMark?.en || "",
          },
        },
        storePhoneInput: {
          countryCode: "+91",
          mobileNumber: data?.storePhoneInput?.storePhone || "",
        },
        longLatCoordinates: {
          longitude: data?.longLattCordinates?.longitude || "",
          latitude: data?.longLattCordinates?.Latitude || "",
        },
        gstNumber: gstResponse?.number || "",
        gstFileKey: gstResponse?.doc?.id || "",
        gstDocKey: gstResponse?.doc?.fileKey || "",
        gstStatus: gstResponse?.status || "",
        panNumber: panResponse?.number || "",
        defaultPanNumber: panResponse?.number || "",
        panFileKey: panResponse?.doc?.id || "",
        panDocKey: panResponse?.doc?.fileKey || "",
        panStatus: panResponse?.status || "",
        gstAddress: {
          en: data?.gstAddress?.en || "",
        },
        licenseRequest: [],
        digitalSignatureUrl: data?.digitalSignatureUrl || null,
        licenseDetails:
          data?.licenseResponses?.length > 0 ? data?.licenseResponses : [],
      });
      setLogo(data?.imageUrl);
    } else {
      setStoreObject({
        categoriesId: [],
        id: storeId || null,
        inStorePickup: false,
        licenseDetails: [],
        licenseRequest: [],
        digitalSignature: null,
      });
      setLogo();
      setGstPan();
      setStatus();
    }
  }, [data]);

  if (loading || detailLoading || updateLoading) {
    return <TableLoader />;
  }

  return (
    <Form>
      <InnerCardHeader name={"Store"} />
      <div className="p-4">
        <GeneralSettings
          storeObject={storeObject}
          setStoreObject={setStoreObject}
          errors={errors}
          setErrors={setErrors}
          logo={logo}
        />
        <div className="separator separator-solid my-5 d-block"></div>
        <GstPan
          gstPan={gstPan}
          storeObject={storeObject}
          setStoreObject={setStoreObject}
          errors={errors}
          setErrors={setErrors}
          GSTregex={GSTregex}
          PANregex={PANregex}
        />
        <div className="separator separator-solid my-5 d-block"></div>
        <UploadedLicense storeObject={storeObject} />
        <div className="separator separator-solid my-5 d-block"></div>
        <UploadLicense
          storeObject={storeObject}
          setStoreObject={setStoreObject}
          licenseError={licenseError}
          setLicenseError={setLicenseError}
        />
        <div className="separator separator-solid my-5 d-block"></div>
        <DigitalSignature
          storeObject={storeObject}
          setStoreObject={setStoreObject}
          errors={errors}
          setErrors={setErrors}
        />
        <div className="separator separator-solid my-5 d-block"></div>
        <Row>
          <Col className="gutter-row" xs={24}>
            <p className="font-weight-bolder font-size-lg mb-3 h5">
              In - Store Pickup{" "}
            </p>
          </Col>

          <Col className="gutter-row" xs={24}>
            <div className="m-0 text-left user_inputs">
              <Checkbox
                checked={storeObject?.inStorePickup === true ? "checked" : ""}
                onChange={(e) => {
                  setStoreObject({
                    ...storeObject,
                    inStorePickup: e.target.checked,
                  });
                }}
              >
                <span className="">
                  This location offers local/ In-store pickup
                </span>
              </Checkbox>
            </div>
          </Col>

          <Col className="gutter-row" xs={24}>
            <div className="separator separator-solid my-5 d-block"></div>
          </Col>
          {storeId && status === "ACTIVE" ? (
            <Col className="gutter-row" xs={24}>
              <p className="font-weight-bolder font-size-lg mb-3 h5">
                Deactivate Store
              </p>
              <p className="d-block font-size-sm font-weight-bold mt-2">
                Deactivate this store if it isn’t used for stocking inventory,
                fulfilling orders, or selling products.
              </p>
              <button
                type="button"
                className="bg-dark border-0 font-weight-bold px-6 py-3 text-white"
                data-toggle="modal"
                data-target="#deactivateStore"
              >
                Deactivate Store
              </button>
            </Col>
          ) : (
            ""
            // <p className="bg-danger font-weight-bold px-4 py-3 text-white">
            //   {" "}
            //   {/* Store is Deactivated */}
            // </p>
          )}
        </Row>

        <Row>
          <Col className="gutter-row" xs={24}>
            <ul className="list-disc">
              <li className="mb-2">
                <strong> (1) Address Line 1 : </strong> Include primary address
                details like street address and building name/number. Use
                abbreviations such as{" "}
                <strong>
                  "St." for Street, "Apt." for Apartment, "Blvd." for Boulevard,
                  etc.,
                </strong>{" "}
                where appropriate to save space and ensure clarity. Ensure
                Address Line 1 does not exceed <strong> 36 characters. </strong>{" "}
                Use this line for additional address information such{" "}
                <strong>
                  as shop number, flat number, road number, apartment number,
                  floor, or any other relevant details.
                </strong>{" "}
                Again, use abbreviations where possible and ensure it fits
                within the
                <strong> 36 characters. </strong> limit.
              </li>{" "}
              <li>
                {" "}
                <strong> (2) Avoid Special Characters : </strong> Do not use
                special characters such as <strong> "&"</strong> which may not
                be universally recognized or could cause issues in printing or
                processing. Stick to alphanumeric characters and standard
                punctuation marks like comma, hyphen, slash, etc.
              </li>
            </ul>
          </Col>
        </Row>

        <div className="my-5 mt-15 text-center">
          <BottomRightButton
            onClick={(e) => {
              e.preventDefault();
              const isGSTValid = storeObject?.gstNumber
                ? (GSTregex.test(storeObject.gstNumber) &&
                  (storeObject?.gstFileKey || storeObject?.gstDoc?.file))
                : false;

              const isPANValid = storeObject?.panNumber
                ? PANregex.test(storeObject.panNumber)
                : false;

              // ✅ Either GST or PAN must be valid
              const isValidGSTorPAN = isGSTValid && isPANValid;

              const isLogoValid = !!(logo || storeObject?.logo?.name);
              const isPincodeValid = /^\d{6}$/.test(
                storeObject?.locationRequest?.storePasscode,
              );

              const hasLicenseErrors = licenseError?.some(
                (err) =>
                  err.productCategoryId ||
                  err.supplierId ||
                  err.licenseNumber ||
                  err.expiryDate ||
                  err.licenseMedia,
              );

              const requiredFields = {
                storeName: storeObject?.storeName?.en,
                storeEmail: storeObject?.storeEmail,
                mobileNumber: storeObject?.storePhoneInput?.mobileNumber,
                storeAddressLine1:
                  storeObject?.locationRequest?.storeAddressLine1?.en,
                storePasscode: isPincodeValid,
                longitude: storeObject?.longLatCoordinates?.longitude,
                latitude: storeObject?.longLatCoordinates?.latitude,
                state: storeObject?.locationRequest?.state?.name?.en,
                city: storeObject?.locationRequest?.city?.name?.en,
                digitalSignature:
                  storeObject?.digitalSignature ||
                  storeObject?.digitalSignatureUrl,
                gstAddress: storeObject?.gstAddress?.en,
              };

              const isAllRequiredValid =
                Object.values(requiredFields).every(Boolean);

              if (
                isAllRequiredValid &&
                isLogoValid &&
                isValidGSTorPAN &&
                !hasLicenseErrors
              ) {
                setErrors({});
                setLicenseError([]);
                const {
                  categoriesId,
                  gstDocKey,
                  panDocKey,
                  gstStatus,
                  panStatus,
                  licenseDetails,
                  digitalSignatureUrl,
                  defaultPanNumber,
                  ...updatedPayload
                } = storeObject;
                // Remove supplierName from each licenseRequest item
                if (!updatedPayload?.digitalSignature) {
                  delete updatedPayload.digitalSignature;
                }
                const cleanedPayload = {
                  ...updatedPayload,
                  licenseRequest:
                    updatedPayload.licenseRequest?.map(
                      ({ supplierName, ...rest }) => rest,
                    ) || [],
                };
                const { id, ...forAdd } = cleanedPayload;

                dispatch(
                  storeId
                    ? UpdateInventory({ payload: cleanedPayload })
                    : AddInventory({ payload: forAdd }),
                );
              } else {
                setErrors({
                  logo: isLogoValid ? "" : "Store Logo is Mandatory",
                  storeName: requiredFields.storeName
                    ? ""
                    : "Store Name is Mandatory",
                  storeEmail: requiredFields.storeEmail
                    ? isValidEmailStrict(requiredFields.storeEmail)
                      ? ""
                      : "Store Email is Invalid"
                    : "Store Email is Mandatory",
                  mobileNumber: requiredFields.mobileNumber
                    ? isTenDigitMobile(requiredFields.mobileNumber)
                      ? ""
                      : "Store Phone Number is Invalid"
                    : "Store Phone Number is Mandatory",
                  storeAddressLine1: requiredFields.storeAddressLine1
                    ? ""
                    : "Store Address Line 01 is Mandatory",
                  storePasscode: storeObject?.locationRequest?.storePasscode
                    ? isPincodeValid
                      ? ""
                      : "Invalid Pincode"
                    : "Pincode/Zip is Mandatory",
                  longitude: requiredFields.longitude
                    ? ""
                    : "Longitude is Mandatory",
                  latitude: requiredFields.latitude
                    ? ""
                    : "Latitude is Mandatory",
                  state: requiredFields.state ? "" : "State is Mandatory",
                  city: requiredFields.city ? "" : "District is Mandatory",
                  digitalSignature:
                    storeObject?.digitalSignature ||
                    storeObject?.digitalSignatureUrl
                      ? ""
                      : "Digital Signature is Mandatory",
                  gstNumber: storeObject?.gstNumber
                    ? GSTregex.test(storeObject.gstNumber)
                      ? ""
                      : "Invalid GST Number"
                    : storeObject?.gstFileKey || storeObject?.panFileKey
                      ? ""
                      : "GST Number is Mandatory",
                  gstDoc: storeObject?.gstDoc?.file || storeObject?.gstFileKey
                      ? ""
                      : "GST Document is Mandatory",
                  panNumber: storeObject?.panNumber
                    ? isPANValid
                      ? ""
                      : "Invalid PAN Number"
                    : "PAN Number is Mandatory",
                    gstAddress: storeObject?.gstAddress?.en ? "" : "GST Address is Mandatory",
                });

                // Optional: You can re-enable this if per-license validation is required
                // setLicenseError(
                //   storeObject.licenseRequest.map((license) => ({
                //     licenseId: license.productCategoryId ? "" : "Category is Mandatory",
                //     supplierId: license.supplierId ? "" : "Sub Category is Mandatory",
                //     licenseNumber: license.licenseNumber ? "" : "License Number is Mandatory",
                //     licenseMedia: license?.file ? "" : "File is Mandatory",
                //   }))
                // );
              }
            }}
            name={"Save"}
          />
        </div>
      </div>
    </Form>
  );
};

export default Store;
